import client from '../request'

const getAll = 'feedbacks'

const get = (id) => {
  return `/feedbacks/${id}`
}

const create = (data) => {
  return client.post('/feedbacks', data)
}

const createHistory = (feedbackId, data) => {
  return client.post(`/feedbacks/${feedbackId}/feedback-histories`, data)
}

const update = (id, data) => {
  return client.put(`/feedbacks/${id}`, data)
}

const remove = (id, data) => {
  return client.delete(`/feedbacks/${id}`, data)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}

const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const FeedbackService = {
  getAll,
  get,
  create,
  update,
  toRow,
  toPaginate,
  remove,
  createHistory
}

export default FeedbackService
